<template>
	<div>
		<!-- Modal -->
		<div class="modal fade" id="consultationModal" tabindex="-1" role="dialog" aria-labelledby="consultationModalL" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="consultationModalL">Modal title</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<contact-form></contact-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ContactForm from '@/components/ContactForm.vue'
	export default {
		components: {ContactForm},
		name: 'ConsultationModal'
	}
</script>



// WEBPACK FOOTER //
// src/components/frontend/ConsultationModal.vue